export default __webpack_public_path__ + "static/media/icon-fleches-vs.b71f9ed6.svg";